<template>
  <universal-tooltip
    :show-tooltip="!!(loginMethodName)"
    :text="loginMethodName || ''"
  >
    <div
      class="flex items-center login-icon"
      :class="{
        'flex-center': centered
      }"
    >
      <q-icon
        v-if="isPasswordLogin"
        name="password"
        :style="{
          'font-size': sizeMultiplier && iconFontSize
        }"
      />
      <q-img
        v-else-if="isGoogleLogin"
        no-spinner
        src="google-auth-128x128.png"
        class="google-icon"
        :width="iconSize"
        :height="iconSize"
      />
      <q-icon
        v-else-if="isAppleLogin"
        name="fab fa-apple apple-login-icon"
        :style="{
          'font-size': sizeMultiplier && iconFontSize
        }"
      />
      <q-img
        v-else-if="isMicrosoftLogin"
        no-spinner
        src="microsoft-auth.png"
        class="microsoft-icon"
        :width="iconSize"
        :height="iconSize"
      />
      <p
        v-else
        class="text-default q-mb-none"
      >
        {{ $t('common.any') }}
      </p>
    </div>
  </universal-tooltip>
</template>

<script>

import UniversalTooltip from 'src/components/UI/UniversalTooltip';
import { useAuth } from 'src/composables/auth';
import { LOGIN_METHOD, LOGIN_METHODS } from 'src/constants/authorization';

const DEFAULT_ICON_SIZE = 35;
const DEFAULT_ICON_FONT_SIZE = 40;

export default {
  name: 'LoginMethodIcon',

  components: {
    UniversalTooltip,
  },

  props: {
    loginMethod: {
      validator: (val) => LOGIN_METHODS.includes(val) || val === null,
      required: true,
    },

    hideTooltip: {
      type: Boolean,
      default: false,
    },

    /**
     * Multiplier to adjust sizes of icons. Examples: `0.5` or `1` or `1.25`
     * We don't use absolute size value as we have different size values for different icons. This makes it very
     * hard to provide a working absolute `size` prop.
     */
    sizeMultiplier: {
      type: Number,
      default: null,
    },

    centered: {
      type: Boolean,
      default: false,
    },
  },

  setup() {
    const { getLoginMethodName } = useAuth();
    return { getLoginMethodName };
  },

  computed: {
    isGoogleLogin() {
      return this.loginMethod === LOGIN_METHOD.GOOGLE;
    }, // isGoogleLogin()

    isAppleLogin() {
      return this.loginMethod === LOGIN_METHOD.APPLE;
    }, // isGoogleLogin()

    isMicrosoftLogin() {
      return this.loginMethod === LOGIN_METHOD.MICROSOFT;
    }, // isGoogleLogin()

    isPasswordLogin() {
      return this.loginMethod === LOGIN_METHOD.PASSWORD;
    }, // isGoogleLogin()

    loginMethodName() {
      return this.hideTooltip ? '' : this.getLoginMethodName(this.loginMethod);
    }, // loginMethodName()

    iconSize() {
      return this.sizeMultiplier
        ? `${(DEFAULT_ICON_SIZE * this.sizeMultiplier)}px`
        : `${DEFAULT_ICON_SIZE}px`;
    }, // iconSize()

    iconFontSize() {
      return this.sizeMultiplier ? `${(DEFAULT_ICON_FONT_SIZE * this.sizeMultiplier)}px` : null;
    }, // iconFontSize()
  },
};
</script>

<style scoped lang="scss">
.login-icon {
  font-size: 40px;
}

.microsoft-icon {
  width: 35px;
  height: 35px;
}

.text-default {
  font-size: 13px;
}
</style>
